import React from "react";
import "./WhyUs.css";
import {
  BulbOutlined,
  ThunderboltOutlined,
  CustomerServiceOutlined,
  RocketOutlined,
  TrophyOutlined,
  SearchOutlined,
  FileDoneOutlined,
  CodeOutlined,
  CloudUploadOutlined,
} from "@ant-design/icons";

function WhyUs() {
  const whyFeatures = [
    {
      icon: <BulbOutlined />,
      title: "Experienced Engineering Team",
      desc: "Our highly-skilled developers build scalable, secure, and modern digital architectures using absolute industry best practices.",
    },
    {
      icon: <ThunderboltOutlined />,
      title: "Agile & On-Time Delivery",
      desc: "We practice strict agile sprint frameworks to deliver complex, production-ready modules with zero compromise on stability.",
    },
    {
      icon: <CustomerServiceOutlined />,
      title: "24/7 Dedicated Support",
      desc: "Get institutional maintenance, real-time cloud monitoring, and dedicated engineering support to ensure zero-downtime.",
    },
    {
      icon: <RocketOutlined />,
      title: "Engineered Business Growth",
      desc: "Our applications optimize workflows, enhance team productivity, and maximize user conversion metrics significantly.",
    },
  ];

  const processSteps = [
    {
      icon: <SearchOutlined />,
      number: "01",
      title: "Discovery & Analysis",
      desc: "We dive deep into your industry landscape, user flows, and product constraints.",
    },
    {
      icon: <FileDoneOutlined />,
      number: "02",
      title: "Strategic Blueprinting",
      desc: "Architecting detailed technical roadmaps, API schemes, and wireframe prototypes.",
    },
    {
      icon: <CodeOutlined />,
      number: "03",
      title: "Sprint-Based Development",
      desc: "Writing clean, modular code with rigorous automated testing & validation protocols.",
    },
    {
      icon: <CloudUploadOutlined />,
      number: "04",
      title: "Seamless Launch & Scale",
      desc: "Deploying to production clouds with optimized continuous integration pipelines.",
    },
  ];

  return (
    <section className="why-sec-light" id="why-us">
      {/* Premium Light Atmospheric Background Elements */}
      <div className="why-bg-grid-light"></div>
      <div className="why-glow-light-1"></div>
      <div className="why-glow-light-2"></div>

      <div className="why-container-light">
        <div className="why-grid-light">
          {/* Left Column: Heading & Key Features */}
          <div className="why-left-light">
            <div className="pill-badge-light">
              <span className="pill-dot-light"></span> WHY CHOOSE YASHVITECH
            </div>

            <h2 className="sec-title-light">
              We Build, Support <br />
              <span className="gradient-text-orange">and Scale</span>{" "}
              <span className="dark-slate-text">With You</span>
            </h2>

            <p className="sec-sub-light">
              We don't just hand over source code and disappear. We act as your internal,
              highly-aligned technology partners—investing engineering excellence in your corporate growth.
            </p>

            <div className="why-feats-light">
              {whyFeatures.map((feature, index) => (
                <div className="why-feat-light" key={index}>
                  <div className="why-feat-icon-light">{feature.icon}</div>
                  <div className="why-feat-content-light">
                    <h4>{feature.title}</h4>
                    <p>{feature.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Column: Premium Stat Card & Flow Steps */}
          <div className="why-right-light">
            {/* High-Impact Trust Card */}
            <div className="why-premium-card-light">
              <div className="premium-trophy-light">
                <TrophyOutlined />
              </div>

              <h3>3+ Years of Zero-Compromise Standards</h3>

              <p>
                From an innovative startup studio in Indore to a highly trusted global software agency—delivering elite product engineering has always been our core vision.
              </p>

              <div className="why-metrics-light">
                <div className="why-metric-light">
                  <div className="why-metric-v-light">500+</div>
                  <div className="why-metric-l-light">Trained Interns</div>
                </div>
                <div className="why-metric-light">
                  <div className="why-metric-v-light">100++</div>
                  <div className="why-metric-l-light">Delivered Projects</div>
                </div>
                <div className="why-metric-light">
                  <div className="why-metric-v-light">4.9★</div>
                  <div className="why-metric-l-light">Rating</div>
                </div>
              </div>
            </div>

            {/* Seamless Process Roadmap */}
            <div className="process-wrap-light">
              <div className="process-header-light">
                <div className="pill-badge-light small">
                  <span className="pill-dot-light"></span> DEPLOYMENT BLUEPRINT
                </div>
                <h3 className="process-title-light">
                  Our Scientific <span className="gradient-text-orange">4-Step</span> Delivery Engine
                </h3>
              </div>

              <div className="process-steps-light">
                {processSteps.map((step, index) => (
                  <div className="process-step-item-light" key={index}>
                    <div className="process-step-icon-box-light">
                      {step.icon}
                      <span className="process-step-num-light">{step.number}</span>
                    </div>
                    <div className="process-step-text-light">
                      <h5>{step.title}</h5>
                      <p>{step.desc}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyUs;